import actions from './actions';

const initState = {
    data: [],
    selectedFacilityCategory: []
};

export default function FacilityCategoryReducer(state = initState, action) {
    switch (action.type) {
        case actions.FacilityCategory_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        case actions.SELECTED_FacilityCategory:
            return {
                ...state,
                selectedFacilityCategory: action.payload.data
            };
        default:
            return state;
    }
}

